export default __webpack_public_path__ + "assets/LUCAS_DA_SILVA_COSTA-DESENVOLVEDOR-CV_PT.d45bb456.pdf";